import { Component, Input } from '@angular/core'
import { CSVService } from './csv.service'
import { IElementFactory, ImageElementFactory, LinkElementFactory, TextElementFactory } from './element';

@Component({
    selector: 'csv-preview',
    template: require('./csvpreview.component.html'),
    styles: [require('./csvpreview.component.scss')],
    providers: [CSVService]
})

export class CSVPreviewComponent {
    public csvData = [];
    public header: any[] = [];

    private displayOutput: Array<Array<string>> = [];
    private displayTemplate: Array<IElementFactory>;

    constructor(private csvService: CSVService) {
    }

    displayData(csv_data: string) {
        this.csvData = this.csvService.parse(csv_data);
        this.displayOutput = [];
        this.initElementTemplates(this.csvData[0]);
        for (let i = 1; i < this.csvData.length; i++) {
            this.displayOutput.push(new Array<string>());
            for (let j = 0; j < this.displayTemplate.length; j++) {
                this.displayOutput[i - 1].push(this.displayTemplate[j].createElement(this.csvData[i]));
            }
        }
    }

    private initElementTemplates(headerRow: Array<string>) {
        this.displayTemplate = new Array<IElementFactory>();
        for (let index = 0; index < headerRow.length; index++) {
            let attrName = this.getAttrFromValueName(headerRow[index]);
            switch (attrName) {
                case 'href': {
                    let hrefIndex = index;
                    let textIndex = -1;
                    if (index + 1 < headerRow.length && // check whether index out of range
                        this.getAttrFromValueName(headerRow[index + 1]) === 'text' && // check whether next field is text
                        // check whether next field is a same selector
                        this.getFieldName(headerRow[index]) === this.getFieldName(headerRow[index + 1])) {
                        textIndex = ++index;
                    }
                    this.displayTemplate.push(new LinkElementFactory(hrefIndex, textIndex));
                } break;
                case 'src': {
                    let srcIndex = index;
                    let altIndex = -1;
                    if (index + 1 < headerRow.length && // check whether index out of range
                        this.getAttrFromValueName(headerRow[index + 1]) === 'alt' && // check whether next field is text
                        // check whether next field is a same selector
                        this.getFieldName(headerRow[index]) === this.getFieldName(headerRow[index + 1])) {
                        altIndex = ++index;
                    }
                    this.displayTemplate.push(new ImageElementFactory(srcIndex, altIndex));
                } break;
                case 'alt':
                case 'text':
                case 'regex': {
                    if (index + 1 < headerRow.length && // check whether index out of range
                        // check whether next field is a same selector
                        this.getFieldName(headerRow[index]) === this.getFieldName(headerRow[index + 1]) &&
                        this.getAttrFromValueName(headerRow[index]) !== this.getAttrFromValueName(headerRow[index + 1])) {
                        let nextFieldAttr = this.getAttrFromValueName(headerRow[index + 1]);
                        switch (nextFieldAttr) {
                            case 'src': {
                                this.displayTemplate.push(new ImageElementFactory(index + 1, index));
                            } break;
                            case 'href': {
                                this.displayTemplate.push(new LinkElementFactory(index + 1, index));
                            } break;
                            default: {
                                throw new Error('Unknown selector type.');
                            }
                        }
                        index++;
                    } else {
                        this.displayTemplate.push(new TextElementFactory(index));
                    }
                } break;
                default: {
                    // TODO: sdelat' krasivo
                    if (index + 1 < headerRow.length && // check whether index out of range
                        // check whether next field is a same selector
                        this.getFieldName(headerRow[index]) === this.getFieldName(headerRow[index + 1]) &&
                        this.getAttrFromValueName(headerRow[index]) !== this.getAttrFromValueName(headerRow[index + 1])) {
                        let nextFieldAttr = this.getAttrFromValueName(headerRow[index + 1]);
                        switch (nextFieldAttr) {
                            case 'src': {
                                this.displayTemplate.push(new ImageElementFactory(index + 1, index));
                            } break;
                            case 'href': {
                                this.displayTemplate.push(new LinkElementFactory(index + 1, index));
                            } break;
                            default: {
                                throw new Error('Unknown selector type.');
                            }
                        }
                        index++;
                    } else {
                        this.displayTemplate.push(new TextElementFactory(index));
                    }
                    //throw new Error('Unknown selector type.');
                }
            }
        }
    }

    private getAttrFromValueName(field: string) {
        let fromIndex = field.lastIndexOf('_');
        if (fromIndex === -1) {
            throw new Error('Attibute name not found');
        }
        return field.substring(fromIndex + 1);
    }

    private getFieldName(field: string) {
        let toIndex = field.lastIndexOf('_');
        if (toIndex === -1) {
            throw new Error('Field name not found');
        }
        return field.substring(0, toIndex);
    }

    private getElementTypeByField(field: string) {
        switch (this.getAttrFromValueName(field)) {
            case 'src': {
                return 0;
            }
            case 'href': {
                return 2;
            }
            default: {
                return 1;
            }
        }
    }

    update(data: string) {
        let str = this.escapeSpecialChars(data);
        let jsonObj = JSON.parse(str);
        this.displayData(jsonObj.tables[0].table);
    }

    escapeSpecialChars(jsonString) {

    return jsonString.replace(/\n/g, '\\n')
        .replace(/\r/g, '\\r')
        .replace(/\t/g, '\\t')
        .replace(/\f/g, '\\f');
    }
}
